export const hasPermission = (permissions, moduleLabel, functionLabel, permissionType, subFunctionLabel = null) => {
    if (!permissions || !Array.isArray(permissions)) {
        console.error('Invalid permissions array');
        return false;
    }

    const module = permissions.find(mod => {
        if (mod.label === moduleLabel) return true;
        
        if (mod.moduleId && typeof mod.moduleId === 'object' && mod.moduleId.label === moduleLabel) return true;
        
        return false;
    });

    if (!module) {
        console.warn(`Module "${moduleLabel}" not found`);
        return false;
    }

    const func = module.functions?.find(f => {
        if (f.label === functionLabel) return true;
        
        if (f.functionId && typeof f.functionId === 'object' && f.functionId.label === functionLabel) return true;
        
        return false;
    });

    if (!func) {
        console.warn(`Function "${functionLabel}" not found in module "${moduleLabel}"`);
        return false;
    }

    if (subFunctionLabel) {
        const subFunc = func.subFunctions?.find(sf => {
            if (sf.label === subFunctionLabel) return true;
            
            if (sf.functionId && typeof sf.functionId === 'object' && sf.functionId.label === subFunctionLabel) return true;
            
            return false;
        });

        if (!subFunc) {
            console.warn(`Subfunction "${subFunctionLabel}" not found in function "${functionLabel}"`);
            return false;
        }

        if (!subFunc.permissions || typeof subFunc.permissions !== 'object') {
            console.warn(`No permissions object for subfunction "${subFunctionLabel}"`);
            return false;
        }

        return subFunc.permissions[permissionType] === true;
    }

    if (!func.permissions || typeof func.permissions !== 'object') {
        console.warn(`No permissions object for function "${functionLabel}"`);
        return false;
    }

    return func.permissions[permissionType] === true;
};